<template>
  <div class="ui-input">
    <label :class="[{ 'not-empty': value, 'has-error': error }, touchedClass]">
      <input
        :type="type"
        :value="value"
        :disabled="disabled"
        :maxlength="maxLength"
        @input="inputChange"
        @blur="lostFocus"
      />
      <span class="input-name">{{ $t(label) }}</span>
      <span class="input-error">{{ $t(error) }}</span>
    </label>
  </div>
</template>

<script>
export default {
  name: 'ui-input',

  props: {
    value: { type: String, default: undefined },
    error: { type: String, default: undefined },
    label: { type: String, default: undefined },
    type: { type: String, default: 'text' },
    maxLength: { type: [String, Number], default: 256 },
    disabled: Boolean
  },

  data() {
    return {
      isTouched: false
    }
  },

  computed: {
    touchedClass() {
      return this.isTouched ? 'ui-touched' : 'ui-untouched'
    }
  },

  methods: {
    inputChange(event) {
      this.$emit('input', event.target.value)
    },

    lostFocus() {
      this.isTouched = true
    }
  }
}
</script>

<style scoped>
.ui-input {
  padding-top: 1rem;
  padding-bottom: 1rem;
}

label {
  position: relative;
  display: block;
}

input {
  font-family: var(--primary-font);
  font-size: 1rem;
  line-height: 1.25;
  border: none;
  display: block;
  width: 100%;
  padding: 0.5rem 1rem;
  color: var(--text-contrast-color);
  outline: none;
  background-color: transparent;
  background-position: 100% 100%;
  background-repeat: no-repeat;
  background-size: 200% 1px;
  background-image: linear-gradient(
    to right,
    var(--dark) 0,
    var(--dark) 50%,
    var(--input-color) 50%,
    var(--input-color) 100%
  );
  transition: background-position var(--input-time) ease-in-out;
}

input:disabled {
  opacity: 0.5;
}

.input-name {
  color: var(--text-contrast-color);
  line-height: 1.5;
  display: block;
  position: absolute;
  top: 0.5rem;
  left: 1rem;
  font-weight: 400;
  transition: all var(--input-time) ease-in-out;
}

.input-error {
  font-size: 0.75rem;
  color: var(--error);
  position: absolute;
  bottom: -1rem;
  opacity: 0;
  transition: opacity var(--input-time) ease-in-out;
}

.ui-touched .input-error {
  opacity: 1;
}

input:focus {
  background-position: 0 100%;
}

.not-empty .input-name,
input:focus + .input-name {
  font-size: 0.75rem;
  top: -1rem;
  left: 0;
}

.has-error.ui-touched > input {
  --input-color: var(--error);
}

.has-error.ui-touched > .input-name {
  color: var(--error);
}
</style>
